import { useAppTranslation } from '@flowus/common/i18n/use-translation';
import { useOpenModal } from '@flowus/common/next-modal';
import type { FC } from 'react';
import { Icon } from 'src/common/components/icon';
import { ProIcon } from 'src/views/main/header/pro-icon';
import { AICoverAside } from './ai-cover-aside';
import { CoverPanel } from './cover-panal';
import { AiCoverStore } from './store';
import { useIsFreeSpaceLimit } from 'src/hooks/space/use-is-pro-space';

export const AICoverId = 'ai-cover';
interface Props {
  chatId?: string;
}

export const AICover: FC<Props> = (props) => {
  const { t } = useAppTranslation();
  const openModal = useOpenModal();
  const html = AiCoverStore((state) => state.html);
  const loading = AiCoverStore((state) => state.loading);
  const isFreeSpaceLimit = useIsFreeSpaceLimit();
  return (
    <div className="w-[960px]">
      <div className="flex items-center px-6 justify-between">
        <div className="flex items-center relative h-[50px]">
          <div className="text-h4">{t('components.share.ai_cover.ai_generated_poster')}</div>
          {isFreeSpaceLimit && <ProIcon isLabel className="-right-9 top-1" />}
        </div>
        <Icon
          name={'IcClose'}
          size="small"
          className="text-grey2"
          onClick={() => {
            openModal.closeModal(AICoverId, {
              closeAfterCallBack() {
                AiCoverStore.setState({ html: '', message: '' });
              },
            });
          }}
        />
      </div>
      <div className="h-px w-full bg-grey6" />
      <div className="flex">
        <AICoverAside
          chatId={props.chatId}
          showQRCode={!!props.chatId}
          showSpaceInfo={!!props.chatId}
        />
        <CoverPanel html={html} loading={loading} />
      </div>
    </div>
  );
};
